module.exports = __webpack_public_path__ + "static/img/16.67f736a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/16.png
// module id = Bcek
// module chunks = 1